import classNames from 'classnames';
import { JsonLd } from 'react-schemaorg';
import { HowTo } from 'schema-dts';

import Typography from '../../core/Typography';
import StepWithDescription from '../base/StepWithDescription';

import useStyles from './styles';
import ISimplifiedStepSection from './types';

function SimplifiedStepSection({
  title,
  label,
  steps,
  cta,
  className,
  stepsClassName,
  headingElement = 'h2',
  labelElement = 'h3',
  stepHeadingElement = 'h3',
}: ISimplifiedStepSection) {
  const classes = useStyles();

  const showSchemaWarning =
    steps.findIndex(({ description }) => typeof description !== 'string') !== -1;

  if (showSchemaWarning) {
    return <div>How to Step Schema org is invalid</div>;
  }

  return (
    <section className={classNames(classes.container, className, 'landing-banner')}>
      <div className={classes.root}>
        {label && (
          <Typography className={classes.label} element={labelElement} look="p">
            {label}
          </Typography>
        )}

        <Typography className={classes.title} element={headingElement}>
          {title}
        </Typography>

        <div className={classNames(classes.steps, stepsClassName)}>
          {steps.map((step, index) => (
            <StepWithDescription
              key={index}
              headingElement={stepHeadingElement}
              index={index + 1}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        <div className={classes.actions}>{cta}</div>
      </div>

      <JsonLd<HowTo>
        item={{
          '@context': 'https://schema.org',
          '@type': 'HowTo',
          name: '',
          step: steps.map((step) => ({
            '@type': 'HowToStep',
            text: step.description,
          })),
        }}
      />
    </section>
  );
}

export default SimplifiedStepSection;
